import { Injectable } from '@angular/core';
import { UploadCacheService, UploadManagerService } from '@techwan/file-upload';
import { UploadsMenuEntry } from '../../schema/menu/uploads-menu-entry';

@Injectable()
export class UploadsMenuControllerService {
  private uploadsMenu: UploadsMenuEntry;

  constructor(private uploadsCache: UploadCacheService, private uploadsManager: UploadManagerService) {}

  setup(uploadsMenu: UploadsMenuEntry) {
    this.uploadsMenu = uploadsMenu;
    this.uploadsManager.$event.subscribe(() => this.onUploadEvent());
  }

  private onUploadEvent() {
    const count: number = this.uploadsCache.getUploadItemsCount();
    this.uploadsMenu.setCounter(count);

    if (count === 0) {
      this.uploadsMenu.disable();
    } else {
      this.uploadsMenu.enable();
    }
  }
}
